import { TinyColor } from '@ctrl/tinycolor';

const clamp01 = (value: number) => Math.min(1, Math.max(0, value));

export default function generatePalette(
    scale: string[],
    total: number
): string[] {
    if (total <= scale.length) return scale.slice(0, total);
    if (!scale.length) return [];

    const extra = total - scale.length;
    const { h, s, l } = new TinyColor(scale[scale.length - 1]).toHsl();
    const step = (1 - l) / (extra + 1);

    const overflow = Array.from({ length: extra }, (_, index) => {
        const lightness = clamp01(l + step * (index + 1));
        return new TinyColor({ h, s, l: lightness }).toHexString();
    });

    return [...scale, ...overflow];
}
